export default __webpack_public_path__ + "static/media/change-password-mobile.7e0b6101.svg";